import * as React from "react";
import "./Workspace.css";
import { ReactComponent as EditSvg } from "../../../assets/Icons/edit (1).svg";
import { ReactComponent as DeleteSvg } from "../../../assets/Icons/Delete _ Default.svg";
import { useOutsideClick } from "../../../hooks/useOutsideClick";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";

export default function DepDrawer({
  deletebtnHandler,
  index,
  setDrawer,
  editbtnHandler,
  previewbtnHandler,
  viewbtnHandler,
  isView,
  editLabel = "Edit",
  previewLabel = "Preview",
  deleteLabel = "Delete",
  showEdit = true,
  showDelete = true,
}) {
  const ref = React.useRef(null);

  const closePopup = () => {
    setDrawer && setDrawer(false);
  };

  useOutsideClick(ref, closePopup);

  return (
    <>
      <div ref={ref} className="wsDrawerActive">
        {isView && (
          <p onClick={viewbtnHandler}>
            <VisibilityOutlinedIcon style={{ width: "18px" }} />
            View
          </p>
        )}

        {!isView && previewbtnHandler && (
          <p onClick={previewbtnHandler}>
            <VisibilityOutlinedIcon style={{ width: "18px" }} />
            {previewLabel}
          </p>
        )}
        {!isView && showEdit && editbtnHandler && (
          <p onClick={editbtnHandler}>
            <EditSvg style={{ width: "15px" }} />
            {editLabel}
          </p>
        )}

        {!isView && showDelete && deletebtnHandler && (
          <p onClick={deletebtnHandler}>
            <DeleteSvg style={{ width: "15px" }} /> {deleteLabel}
          </p>
        )}
      </div>
    </>
  );
}
